const subscriptionSelector = class extends HTMLElement {
  constructor() {
    super();
    this.label = this.querySelector('[data-subscription-selector-label]');
    this.select = this.querySelector('[data-subscription-selector-select]');
    this.selectWrapper = this.querySelector('[data-subscription-selector-select-wrapper]');
    this.infoToggle = this.querySelector('[data-subscription-selector-info-toggle]');
    this.infoPopup = this.querySelector('[data-subscription-selector-info-popup]');
    this.infoPopupClose = this.querySelector('[data-subscription-selector-info-popup-close]');
    this.sellingPlanIdInput = this.querySelector('[data-subscription-selector-selling-plan-id]');

    this.label.addEventListener('click', () => this.toggleSelect());
    this.infoToggle.addEventListener('click', () => this.toggleInfoPopup());
    this.infoPopupClose.addEventListener('click', () => this.closeInfoPopup());
    this.select.addEventListener('change', () => this.updateSellingPlanId());
  }

  toggleSelect() {
    this.selectWrapper.classList.toggle('hide');

    if (this.select.hasAttribute('data-key')) {
      if (this.selectWrapper.classList.contains('hide')) {
        const requestBody = {
          id: this.select.getAttribute('data-key'),
          selling_plan: null,
        };

        this.changeLineItem(requestBody);
      } else {
        const requestBody = {
          id: this.select.getAttribute('data-key'),
          selling_plan: this.select.value,
        };

        this.changeLineItem(requestBody);
      }
    } else {
      if (this.selectWrapper.classList.contains('hide')) {
        this.sellingPlanIdInput.value = '';
      } else {
        this.updateSellingPlanId();
      }
    }
  }

  changeLineItem(requestBody) {
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest',
      },
      body: JSON.stringify(requestBody),
    }).then((response) => {
      return response.json();
    }).then((result) => {
      if (result.status) {
        throw new Error(result.description);
      };

      document.dispatchEvent(new Event('refreshCart'));

      return null;
    }).catch((error) => {
      alert(error);
    });
  }

  updateSellingPlanId() {
    if (this.select.hasAttribute('data-key')) {
      const requestBody = {
        id: this.select.getAttribute('data-key'),
        selling_plan: this.select.value,
      };

      this.changeLineItem(requestBody);
    } else {
      this.sellingPlanIdInput.value = this.select.value;
    }
  }

  toggleInfoPopup() {
    this.infoPopup.classList.toggle('hide');
  }

  closeInfoPopup() {
    this.infoPopup.classList.add('hide');
  }
};

if (typeof window.customElements.get('subscription-selector') === 'undefined') {
  window.customElements.define('subscription-selector', subscriptionSelector);
}
